/**
 * URIチェック
 * @param {String} uri チェック対象URI(日本語ドメイン可)
 */
function isUri(uri) {
  let isUri = false
  if (!uri) {
    return isUri
  }
  // 日本語ドメインも存在するので、簡易チェック
  const matchUri = uri.match(/https?:\/[^\s]+\.[^\s]+/)
  if (matchUri) {
    // URIの正規表現に当てはまる
    isUri = true
  } else {
    // URIの正規表現に当てはまらない
    isUri = false
  }
  return isUri
}
/**
 * メールアドレスチェック
 * @param {String} mailAddress チェック対象メールアドレス(日本語ドメイン可)
 * @param {String} strName チェック対象データの名称
 */
function isMailAddress(mailAddress, strName) {
  let strError = ''
  if (!mailAddress) {
    strError = strName + 'を入力してください。'
    return strError
  }
  // 長さチェック
  if (mailAddress.length > 254) {
    strError = strName + 'は254文字以内で入力してください。'
    return strError
  }
  // 日本語ドメインも存在するので、簡易チェック
  const matchMail = mailAddress.match(/[^\s]+@[^\s]+\.[^\s]+/)
  if (matchMail) {
    // URIの正規表現に当てはまる
    strError = ''
  } else {
    // URIの正規表現に当てはまらない
    strError = strName + 'の形式が正しくありません。'
  }
  return strError
}
/**
 * SMS送信元チェック
 * @param {String} smsAddress チェック対象送信元(日本語不可)
 * @param {String} companySMSTEL 会社情報のSMS番号
 * @param {String} strName チェック対象データの名称
 */
function isSMSAddress(smsAddress, companySMSTEL, strName) {
  if (!smsAddress) {
    return null
  }
  let strError = ''
  // 長さチェック
  if (smsAddress.length > 11) {
    strError = strName + 'は11文字以内で入力してください。'
    return strError
  }

  let isCheck1 = false    // 数字チェック
  let isCheck2 = false    // 英数字チェック
  let isCheck3 = false    // 英字チェック

  // 数字チェック
  const matchMail1 = smsAddress.match(/[^0-9]/)
  if (matchMail1) {
    isCheck1 = false
  } else {
    isCheck1 = true
  }

  // 英数字チェック
  const matchMail2 = smsAddress.match(/[^0-9A-Za-z]/)
  if (matchMail2) {
    isCheck2 = false
  } else {
    isCheck2 = true
  }

  // 英字チェック
  const matchMail3 = smsAddress.match(/[a-zA-Z]/)
  if (matchMail3) {
    isCheck3 = true
  } else {
    isCheck3 = false
  }

  // Twillio番号の有無で、チェック内容を切り替える
  if (!companySMSTEL) {
    // 番号無しの場合は、check2&check3がOKであることを確認
    if (isCheck2 && isCheck3) {
      strError = ''
    } else if (isCheck1) {
      strError = '会社指定のSMS番号がない場合、' + strName + 'には英字を含めた英数字で指定してください。'
    } else {
      strError = strName + 'は半角英数字のみで入力してください。'
    }
  } else {
    // 番号有りの場合は、check1もしくはcheck2&check3のいずれかがOKであることを確認
    if (isCheck1) {
      strError = ''
    } else if (isCheck2 && isCheck3) {
      strError = ''
    } else {
      strError = strName + 'は半角英数字のみで入力してください。'
    }
  }
  return strError
}
/**
 * 日付チェック（時間なし）
 * @param {String} dateStr チェック対象日付
 */
function isDate(dateStr) {
  if (typeof dateStr == 'string') {
    let str = dateStr.replace(/-/g, '/')
    let match = str.match(/^(\d+)\/(\d+)\/(\d+)$/)
    if (match) {
      const y = parseInt(match[1])
      const m = parseInt(match[2]) - 1
      const d = parseInt(match[3])
      const x = new Date(y, m, d)
      return y == x.getFullYear() && m == x.getMonth() && d == x.getDate()
    }
  }
  return false
}
/**
 * 日付チェック（時間あり HH:MM:SS）
 * @param {String} dateStr チェック対象日付
 */
function isDateTime(dateStr) {
  if (typeof dateStr == 'string') {
    let str = dateStr.replace(/-/g, '/')
    let match = str.match(/^(\d+)\/(\d+)\/(\d+) ([01]?[0-9]|2[0-3]):([0-5][0-9]):([0-5][0-9])$/)
    if (match) {
      const y = parseInt(match[1])
      const m = parseInt(match[2]) - 1
      const d = parseInt(match[3])
      const x = new Date(y, m, d)
      return y == x.getFullYear() && m == x.getMonth() && d == x.getDate()
    }
  }
  return false
}
/**
 * 未入力チェック
 * @param {String} strValue チェック対象データ
 * @param {String} strName チェック対象データの名称
 */
function isDataNull(strValue, strName) {
  let strError = ''

  if (!strValue) {
    strError = strName + 'が入力されていません。'
  } else if (strValue == '') {
    strError = strName + 'が入力されていません。'
  }
  return strError
}
export { isUri, isMailAddress, isSMSAddress, isDate, isDateTime, isDataNull }



// WEBPACK FOOTER //
// ./src/functions/common/checksFunc.js